"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var Sorting = (function () {
    function Sorting() {
    }
    Sorting.sortTeaserCruises = function (cruises) {
        var promoCruises = _.filter(cruises, function (cru) { return cru.promotion; });
        var nonPromoCruises = _.filter(cruises, function (cru) { return !cru.promotion; });
        var promoSorted = _.orderBy(promoCruises, ['price'], ['asc']);
        var otherCruises = _.concat(_.slice(promoSorted, 1), nonPromoCruises);
        var othersSorted = _.orderBy(otherCruises, ['code'], ['asc']);
        return _.concat([promoSorted[0]], othersSorted);
    };
    Sorting.sortTeaserOffers = function (offers) {
        var sortProps = ['cheapestPrice', 'routeName'];
        var sortOrder = ['asc', 'asc'];
        var bookableOrdered = _.orderBy(offers, ['bookableUntil'], ['desc']);
        var bookableUntil = bookableOrdered[0].bookableUntil;
        var newestOffers = _.remove(bookableOrdered, function (offer) {
            return offer.bookableUntil === bookableUntil;
        });
        var sortedNew = Sorting.sortOffers(newestOffers, sortProps, sortOrder);
        var sortedOld = Sorting.sortOffers(bookableOrdered, sortProps, sortOrder);
        return _.concat(sortedNew, sortedOld);
    };
    Sorting.sortOffers = function (offers, props, order) {
        var promoOffers = _.remove(offers, function (offer) {
            return offer.cruises[0].campaignFocus > 0;
        });
        var sortedDefaults = _.orderBy(offers, props, order);
        var prioProps = _.concat(['campaignFocus'], props);
        var prioOrder = _.concat(['asc'], order);
        var sortedPromos = _.orderBy(promoOffers, prioProps, prioOrder);
        return _.concat(sortedPromos, sortedDefaults);
    };
    return Sorting;
}());
exports.Sorting = Sorting;
//# sourceMappingURL=sorting.js.map